import { createSlice } from '@reduxjs/toolkit';
import { getCustomerInfo } from '../actions/donationsActions';

interface DonationsState {
  customerId: string;
  hasActiveSubscription: boolean;
  isCanceling: boolean;
  hasCanceledSubscription: boolean;
  isLoading: boolean;
  hasFetched: boolean;
}

const initialState: DonationsState = {
  customerId: '',
  hasActiveSubscription: false,
  isCanceling: false,
  hasCanceledSubscription: false,
  isLoading: false,
  hasFetched: false,
};

const donationsSlice = createSlice({
  name: 'donations',
  initialState,
  reducers: {
    clearDonationsState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCustomerInfo.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCustomerInfo.fulfilled, (state, action) => {
        state.customerId = action.payload?.stripe_customer_id || '';
        state.hasActiveSubscription = action.payload?.has_active_subscription ?? false;
        state.isCanceling = action.payload?.is_canceling ?? false;
        state.hasCanceledSubscription = action.payload?.has_canceled_subscription ?? false;
        state.isLoading = false;
        state.hasFetched = true;
      })
      .addCase(getCustomerInfo.rejected, (state) => {
        state.customerId = '';
        state.isLoading = false;
        state.hasFetched = true;
      });
  },
});

export const { clearDonationsState } = donationsSlice.actions;
export default donationsSlice.reducer;